import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

export default withStyles(theme => ({
  root: {
    maxWidth: '100px', // Make it possible to have ellipsis truncation on elements directly on td: https://stackoverflow.com/a/11877033
  },
  head: {
    backgroundColor: theme.palette.facet.lightGray,
    color: theme.palette.facet.primaryBlue,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body1.fontSize,
    padding: theme.spacing(1.5),
  },
  body: {
    fontSize: theme.typography.body1.fontSize,
    color: theme.palette.facet.darkGray,
    fontWeight: theme.typography.fontWeightMedium,
    padding: theme.spacing(1.35),
  },
}))(TableCell);
